import { MOBILE_APP_ROUTES } from 'shared/consts/routes/mobile-app';
import { MenuAddButton } from 'shared/ui/section-menu';

export function AddButton() {
  return (
    <MenuAddButton
      path={MOBILE_APP_ROUTES.ADD_MOBILE_APP}
      requiredRights={[
        {
          controller: 'MobileApp',
          right: 'Write',
        },
      ]}
    />
  );
}
